import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/messaging'
import 'firebase/database'

let configServer = {
  apiKey: 'AIzaSyAH0CRmCV6zWB8rqZAgtPD6tO6QZl8tXHU',
  authDomain: 'chat-infinite.firebaseapp.com',
  databaseURL: 'https://chat-infinite.firebaseio.com',
  projectId: 'chat-infinite',
  storageBucket: 'chat-infinite.appspot.com',
  messagingSenderId: '921907784236',
}

let configClient = {
  /* CI BANK */
  apiKey: 'AIzaSyCHU86xU-M2zxWg8lnuJOD9WhdPVhQ5CTM',
  authDomain: 'ci-bank-f7673.firebaseapp.com',
  databaseURL: 'https://ci-bank-f7673.firebaseio.com',
  projectId: 'ci-bank-f7673',
  storageBucket: 'ci-bank-f7673.appspot.com',
  messagingSenderId: '931934724781',
}

/* let configClient = {
  apiKey: 'AIzaSyAtx1NqOWzYQq5slsvK9OTj3DJti8hm4wk',
  authDomain: 'newagent-1faac.firebaseapp.com',
  databaseURL: 'https://newagent-1faac.firebaseio.com',
  messagingSenderId: 293510565120,
  projectId: 'newagent-1faac',
  storageBucket: 'newagent-1faac.appspot.com'
} */

// Log Param
// function test(key, bot) {
//   client = firebase.initializeApp({
//     apiKey: key.apiKey,
//     authDomain: key.authDomain,
//     databaseURL: key.databaseURL,
//     projectId: key.projectId,
//     storageBucket: key.storageBucket,
//     messagingSenderId: key.messagingSenderId,
//   }, bot).database()
//   console.log('called', bot, key)
// }

let firebaseServer = firebase.initializeApp(configServer, 'server')
let firebaseClient = firebase.initializeApp(configClient, 'client')

export const db = firebaseClient.database()
export const auth = firebaseServer.auth()
export const metadb = firebaseServer.database()
export const notif = firebaseServer.messaging()
// export { test as testdb }



// WEBPACK FOOTER //
// ./src/firebase.js